/**
 * Markup Gramax hangs on a native Markdown element instead of replacing it with a tag:
 * `| Элемент {width=180px} |`, `![](./y.jpeg){width=700px}`, ` ```mermaid {scale=476px} `.
 */

const QUOTES = ['"', "'"];
const isSpace = (char: string) => /\s/.test(char);

/** Braces hold markup only when they hold `name=value` pairs. A word in braces is the text of the article. */
export const parseBraceAttrs = (source: string): Record<string, string> | null => {
	const text = source?.trim() ?? "";
	if (text[0] !== "{") return null;

	const attrs: Record<string, string> = {};
	let i = 1;

	while (i < text.length && text[i] !== "}") {
		if (isSpace(text[i])) {
			i++;
			continue;
		}

		let name = "";
		while (i < text.length && !isSpace(text[i]) && text[i] !== "=" && text[i] !== "}") {
			name += text[i];
			i++;
		}
		if (!name || text[i] !== "=") return null;
		i++;

		let value = "";
		if (QUOTES.includes(text[i])) {
			const quote = text[i];
			i++;
			while (i < text.length && text[i] !== quote) {
				if (text[i] === "\\" && i + 1 < text.length) i++;
				value += text[i];
				i++;
			}
			i++;
		} else {
			while (i < text.length && !isSpace(text[i]) && text[i] !== "}") {
				value += text[i];
				i++;
			}
		}

		attrs[name] = value;
	}

	if (text[i] !== "}") return null;
	return Object.keys(attrs).length ? attrs : null;
};

const needsQuotes = (value: string) => /[\s"'{}=\\]/.test(value);

export const formatBraceAttrs = (attrs: Record<string, string | number>): string => {
	const pairs = Object.entries(attrs ?? {})
		.filter(([, value]) => value !== null && value !== undefined && value !== "")
		.map(([name, value]) => {
			const text = String(value);
			return `${name}=${needsQuotes(text) ? `"${text.replace(/([\\"])/g, "\\$1")}"` : text}`;
		});

	return pairs.length ? `{${pairs.join(" ")}}` : "";
};
